import React from "react";
import FeedbackContainer from "../Shared/FeedbackContainer";

export default function QAFeedbackContainer() {
    return (
        <FeedbackContainer view='QA' />
    );
}